<template>
    <data-table
        :id="state_identifier"
        :columns="visible_columns"
        :rows="filtered_rows"
        :search="state.search"
        :total="state.total"
        :found="state.found"
        :current-page="state.page"
        :total-pages="nb_pages"
        :searchable="false"
        table-class="uk-table-condensed uk-table-hover lam-subrecords-list"
        empty-title="No projects found"
        @sort="sort_by"
        @search="search"
        @page="goto_page"
        @click="record_edit(entity, $event.id)"
    >
        <template
            v-slot:summary="{ row }"
        >
            <h6>{{ row.name }}</h6>
        </template>
        <template
            v-slot:tbody="{ row, field }"
        >
            <span v-if="field === 'sortable_number'">{{ row.sortable_number | lam.project-number }}</span>
            <span v-else-if="field === 'completed_at_as_string'">{{ row.completed_at_as_string | nibnut.date("MMMM DD") }}</span>
            <span v-else>{{ row[field] }}</span>
       </template>
    </data-table>
</template>

<script type="text/javascript">
import dashboard_card from "./dashboard_card"
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"

export default {
    mixins: [dashboard_card, is_remote_data_table_source],
    computed: {
        state_identifier () {
            return `Dashboard-${this.card.type}`
        }
        /*
        projects () {
            return this.all_projects.filter((project) => {
                if(!this.profile || !project.completed_at) return false
                return true
            })
        },
        records () {
            return this.projects.filter((project) => {
                return true
            })
        },
        fields () {
            let fields = []

            fields.push({name: 'sortable_number', header: "Number", cellClass: "uk-text-center lam-col-number", sortBy: true, render: (h, { props }) => h(ProjectNumberCell, { props }), entity: "project"})
            fields.push({name: 'name', header: "Project", cellClass: "lam-col-project-name", sortBy: true, render: (h, { props }) => h(LinkCell, { props }), href: { name: 'project.edit', params: { id: 0 }}, entity: "project"})
            fields.push({name: 'completed_at', header: "Completed", cellClass: "uk-text-center lam-col-date", sortBy: true, render: (h, { props }) => h(DateCell, { props }), entity: "project", format: "MMMM DD"})

            return fields
        },
        initial_sort () {
            return {'completed_at': 'desc'}
        },
        */
    },
    data () {
        return {
            entity: "project",
            columns: {
                sortable_number: { label: "Number", sort: null, type: "plain", cell_class: "uk-text-center lam-col-number" },
                name: { label: "Project", sort: null, type: "plain", cell_class: "lam-col-project-name" },
                completed_at_as_string: { label: "Completed", sort: null, type: "plain", cell_class: "lam-col-date" }
            },

            default_state: {
                per_page: 10,
                page: 1,
                sort_by: "completed_at",
                sort_dir: "desc",
                filter_on: null,
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "dashboard-completed",
                activated_at: 1
            }
        }
    }
}
</script>
